import {
  AutoLink,
  Autosave,
  BlockQuote,
  Bold,
  CKBox,
  CloudServices,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  ImageBlock,
  ImageInsert,
  ImageInsertViaUrl,
  ImageResize,
  ImageToolbar,
  ImageUpload,
  Indent,
  Italic,
  Link,
  LinkImage,
  List,
  MediaEmbed,
  Paragraph,
  PictureEditing,
  SelectAll,
  SourceEditing,
  Table,
  TableToolbar,
  Undo,
} from 'ckeditor5';
import { UserRoles } from '../enums/enums';
import { BlogFilter, NavItemModel } from '../interface/interface';
export const URLS = {
  signin: 'users/sign-in',
  profile: 'users/profile',
  refreshToken: 'users/refresh',
  blogs: 'admin/blog',
  news: 'admin/news',
  mediaSignedUrl: 'admin/media/signed-url',
  category: 'api/category',
  topic: 'admin/topic',
  question: 'admin/faq',
  users: 'users',
  changePassword: 'users/change-password',
  video: 'video',
  author: 'author',
  salesTrackerSummary: 'api/sales-tracker/summary',
  salesTrackerOwnerSummary: 'api/sales-tracker/owner-summary',
  mediaContacts: 'api/media-contacts',
};

export const ALLOWED_IMAGE_TYPE = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
  'image/webp',
];
export const DEFAULT_FILTER = { searchText: '', pageNumber: 1, limit: 10 };
export const DEFAULT_BLOG_FILTER: BlogFilter = {
  searchText: '',
  pageNumber: 1,
  limit: 10,
  categorySlug: '',
};

export const EMPLOYEE_NAV_ITEMS: NavItemModel[] = [
  {
    label: 'Videos',
    activeIcon: 'assets/images/video.svg',
    icon: 'assets/images/video-white.svg',
    url: '/videos',
  },
  {
    label: 'Sales Dashboard',
    activeIcon: 'assets/images/author.svg',
    icon: 'assets/images/author-white.svg',
    url: '/sales-dashboard',
  },
];
export const EMPLOYEE_ALLOWED_URLS: string[] = [
  '/videos',
  '/profile',
  '/sales-dashboard',
];
export const ADMIN_ALLOWED_URLS: string[] = [
  '/',
  '/categories',
  '/faq',
  '/users',
  '/videos',
  '/add-blog',
  '/edit-blog',
  '/add-user',
  '/add-video',
  '/edit-video',
  '/authors',
  '/add-author',
  '/edit-author',
  '/news',
  '/add-news',
  '/edit-news',
  '/sales-dashboard',
  '/impact-partners',
  '/customers',
];
export const ADMIN_NAV_ITEMS: NavItemModel[] = [
  {
    label: 'Blog',
    activeIcon: 'assets/images/doc-edit.svg',
    icon: 'assets/images/doc-edit-white.svg',
    url: '/',
    activeUrls: ['/'],
  },
  {
    label: 'News',
    activeIcon: 'assets/images/news.svg',
    icon: 'assets/images/news-white.svg',
    url: '/news',
  },
  {
    label: 'Categories',
    activeIcon: 'assets/images/categories.svg',
    icon: 'assets/images/categories-white.svg',
    url: '/categories',
  },
  {
    label: 'FAQ',
    activeIcon: 'assets/images/faq.svg',
    icon: 'assets/images/faq-white.svg',
    url: '/faq',
  },
  {
    label: 'Users',
    activeIcon: 'assets/images/users.svg',
    icon: 'assets/images/users-white.svg',
    url: '/users',
  },
  {
    label: 'Video',
    activeIcon: 'assets/images/video.svg',
    icon: 'assets/images/video-white.svg',
    url: '/videos',
  },
  {
    label: 'Author',
    activeIcon: 'assets/images/author.svg',
    icon: 'assets/images/author-white.svg',
    url: '/authors',
  },
  {
    label: 'Sales Dashboard',
    activeIcon: 'assets/images/dashboard.svg',
    icon: 'assets/images/dashboard-white.svg',
    url: '/sales-dashboard',
  },
  {
    label: 'Add Partners',
    activeIcon: 'assets/images/partner.svg',
    icon: 'assets/images/partner-white.svg',
    url: '/impact-partners',
  },
  {
    label: 'Customers',
    activeIcon: 'assets/images/customer.svg',
    icon: 'assets/images/customer-white.svg',
    url: '/customers',
  },
];

export const NAV_ITEMS: { [key: string]: NavItemModel[] } = {
  [UserRoles.ADMIN]: ADMIN_NAV_ITEMS,
  [UserRoles.EMPLOYEE]: EMPLOYEE_NAV_ITEMS,
};

export const SLIDER_CONFIG = {
  slidesToShow: 4,
  infinite: false,
  draggable: true,
  responsive: [
    {
      breakpoint: 1279,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
        arrows: false,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1.3,
        arrows: false,
        dots: true,
      },
    },
  ],
};

export const USER_ROLES_OPTIONS = [
  { label: 'Employee', value: UserRoles.EMPLOYEE },
];

export const ALLOWED_VIDEO_TYPE = ['video/mp4', 'video/quicktime', '.mkv'];
export const TOTAL_PERCENTAGE = 100;

export const EDITOR_CONFIG = {
  htmlSupport: {
    allow: [
      {
        name: 'img',
        attributes: true,
        classes: true,
        styles: true,
      },
    ],
  },
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      '|',
      'indent',
      'outdent',
      '|',
      'insertImage',
      'ckbox',
      'insertTable',
      'blockQuote',
      'mediaEmbed',
      'undo',
      'redo',
      '|',
      'fontSize',
      'fontFamily',
      'fontColor',
      'fontBackgroundColor',
      'sourceEditing',
    ],
    shouldNotGroupWhenFull: false,
  },
  plugins: [
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    CKBox,
    CloudServices,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    Heading,
    ImageBlock,
    ImageInsert,
    ImageInsertViaUrl,
    ImageResize,
    ImageToolbar,
    ImageUpload,
    Indent,
    Italic,
    Link,
    List,
    Paragraph,
    PictureEditing,
    SelectAll,
    Table,
    TableToolbar,
    Undo,
    MediaEmbed,
    LinkImage,
    SourceEditing,
    GeneralHtmlSupport,
  ],
  fontFamily: {
    supportAllValues: true,
  },
  fontSize: {
    options: [10, 12, 14, 'default', 18, 20, 22],
    supportAllValues: true,
  },
  heading: {
    options: [
      {
        model: 'paragraph',
        title: 'Paragraph',
        class: 'ck-heading_paragraph',
      },
      {
        model: 'heading1',
        view: 'h1',
        title: 'Heading 1',
        class: 'ck-heading_heading1',
      },
      {
        model: 'heading2',
        view: 'h2',
        title: 'Heading 2',
        class: 'ck-heading_heading2',
      },
      {
        model: 'heading3',
        view: 'h3',
        title: 'Heading 3',
        class: 'ck-heading_heading3',
      },
      {
        model: 'heading4',
        view: 'h4',
        title: 'Heading 4',
        class: 'ck-heading_heading4',
      },
      {
        model: 'heading5',
        view: 'h5',
        title: 'Heading 5',
        class: 'ck-heading_heading5',
      },
      {
        model: 'heading6',
        view: 'h6',
        title: 'Heading 6',
        class: 'ck-heading_heading6',
      },
    ],
  },
  image: {
    toolbar: ['imageTextAlternative', '|', 'resizeImage'],
  },
  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: 'https://',
    decorators: {
      toggleDownloadable: {
        mode: 'manual',
        label: 'Downloadable',
        attributes: {
          download: 'file',
        },
      },
    },
  },
  placeholder: 'Type or paste your content here!',
  table: {
    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
  },
  mediaEmbed: { previewsInData: true },
};

export const ALLOWED_AUDIO_TYPE = ['audio/mpeg', 'audio/wav'];
